function markPromiseHandled(promise) {
  promise.catch(function () {});
  return promise;
}

function runPromiseCallback(promise, callback) {
  if (typeof callback === "function") {
    markPromiseHandled(promise.then(callback));
  }

  return promise;
}

module.exports = {
  markPromiseHandled,
  runPromiseCallback,
};
